import { createContext } from "react";

export const SectionContext = createContext();

export const LanguageContext = createContext();